import { type ShipmentOrderInfo } from '@/features/vehicle-dispatch-boards/formatters'
import {
  type ShipmentOrdersListExEntity,
  type DispatchListDetailShipmentOrderExEntity
} from '@/libs/api'

/**
 * 配車詳細 - パッケージカテゴリー集計データ
 */
export type ShipmentOrdersPackageCategorySummaryData = {
  categoryId: number | null
  name: string
  totalCount: number
}

export const mapToShipmentOrdersPackageCategorySummaryData = (
  shipmentOrders:
    | DispatchListDetailShipmentOrderExEntity[]
    | ShipmentOrdersListExEntity[]
    | ShipmentOrderInfo[]
): ShipmentOrdersPackageCategorySummaryData[] => {
  return shipmentOrders.reduce(
    (acc: ShipmentOrdersPackageCategorySummaryData[], order) => {
      const group = order.group
      if (!group) return acc
      const categoryId =
        'packageCategoryId' in group
          ? group.packageCategoryId
          : (group.packageCategory?.id ?? null)
      const categoryName = group.packageCategory?.name || ''

      const packageCategorySummary = acc.find(
        (summary) => summary.categoryId === categoryId
      )
      if (packageCategorySummary) {
        packageCategorySummary.totalCount += order.packageCount
      } else {
        acc.push({
          categoryId,
          name: categoryName,
          totalCount: order.packageCount
        })
      }
      return acc
    },
    []
  )
}
